import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import './index.scss';
import billsClient from './common/apolloBillsClient';
import ReactGA from 'react-ga4';

const container = document.getElementById('root');
const root = createRoot(container!);

const GA_TOKEN: string = process.env.REACT_APP_GA_TOKEN || '';
ReactGA.initialize(GA_TOKEN);

root.render(
  <ApolloProvider client={billsClient}>
    <App />
  </ApolloProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
